import type { ClaimBriefMutation } from '../../graph';
import type { StructuredBriefFragment } from '../BriefForm/brief.generated';

export function getWorkIdFromDynamicFields(
    dynamicFields: ClaimBriefMutation['claimStructuredBrief']['dynamicFields']
): string | undefined {
    return dynamicFields
        .flatMap((df) => {
            if (df.__typename === 'WorkEntityField') {
                return [df.workEntityValue];
            }
            return [];
        })
        .pop();
}

export function getTitleFromDynamicFields(
    dynamicFields: StructuredBriefFragment['dynamicFields']
): string | undefined {
    const titleField = dynamicFields.find((field) => field.id === 'title');

    if (!titleField) {
        return undefined;
    }

    if (titleField.__typename === 'InputField') {
        return titleField.inputValue || undefined;
    }

    return undefined;
}
